import { createAction } from '@sde/widgets-core/src/redux/helpers/createAction';
import { SET_TAB_INDEX, SET_VISIBLE_TABS } from './constants';

export const setTabIndex = (payload) => {
  return createAction({
    type: SET_TAB_INDEX,
    payload,
  });
};

export const setVisibleTabs = (payload) => {
  return createAction({
    type: SET_VISIBLE_TABS,
    payload,
  });
};
